import { ContentBlock, useBlockContext } from "eddev/blocks"
import { useEffect, useRef } from "react"

const RichText = (props: ContentBlock) => {
  console.log(props)
  if (typeof props.innerHTML === "string") {
    return <div className="contents rich-wysiwyg" data-transition="children/fade" dangerouslySetInnerHTML={{ __html: props.innerHTML }}></div>
  } else {
    return null
  }
}

const HTMLBlock = (props: ContentBlock) => {
  const ref = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const scriptEl = document.createRange().createContextualFragment(props.innerHTML ?? "")
    ref.current?.append(scriptEl)
  }, [])

  if (typeof props.innerHTML === "string") {
    return <div ref={ref} className="contents rich-wysiwyg" data-transition="children/fade"></div>
  } else {
    return null
  }
}

function nodeScriptReplace(node: HTMLElement) {
  const scripts = node.querySelectorAll("script")
  scripts.forEach((script) => {
    const newScript = nodeScriptClone(script as HTMLElement)
    script.parentNode?.replaceChild(newScript, script)
  })
  // if (nodeScriptIs(node) === true) {
  //   node.parentNode?.replaceChild(nodeScriptClone(node), node)
  // } else {
  //   var i = -1,
  //     children = node.childNodes
  //   while (++i < children.length) {
  //     nodeScriptReplace(children[i] as HTMLElement)
  //   }
  // }

  // return node
}
function nodeScriptClone(node: HTMLElement) {
  var script = document.createElement("script")
  script.text = node.innerHTML

  var i = -1,
    attrs = node.attributes,
    attr
  while (++i < attrs.length) {
    script.setAttribute((attr = attrs[i]).name, attr.value)
  }
  return script
}

function nodeScriptIs(node: HTMLElement) {
  return node.tagName === "SCRIPT"
}

export default {
  "core/html": HTMLBlock,
  "core/rich-text": RichText,
}
